module.exports = __webpack_public_path__ + "static/media/video2.a92f82f7.mp4";